import styled from 'styled-components';
import bgImage from '@design-system/Assets/auth_bg.png';
import { mediaQuery } from '@design-system/Breakpoints/Breakpoints';

export const Background = styled.div`
  display: block;
  background: url(${bgImage}) no-repeat,
    linear-gradient(45deg, #003232 0%, #549a9a 100%);
  height: 100vh;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 1;

  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .mobile-image {
      width: 80%;
      height: 800px;
      object-fit: center;
      position: relative;
      z-index: 1;
      ${'' /* padding-left: 20px */}
      ${'' /* margin-top: 200px */}
    }

    .badges-content {
      display: grid;
      position: absolute;
      place-items: center;
      top: 75%;
      margin-left: 150px;
      z-index: 2;
    }

    .badges {
      display: flex;
      flex-direction: row;
      gap: 17px;
      margin-top: 8px;
    }
  }

  @media screen and (max-width: 992px) {
    display: none;
  }
`;

export const ForgotPassword = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;

  .remember {
    display: flex;
    gap: 8px;
    align-items: center;
  }
`;

export const Container = styled.div`
  height: 100vh;
  display: grid;
  place-items: center;
  padding: 20px;

  .image {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    margin: 0 0 -25% -58%;
  }

  form {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  ${mediaQuery.desktop`

height: 100vh;
display: grid;
place-items: center;
padding: 0;

form {
  display: flex;
  flex-direction: column;
  width: 360px;
}

.image {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    margin: 0 0 -15% -35%;
  }

  .images {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    margin: 0 0 -15% -30%;
  }

 

`}
`;
